import { combineReducers } from 'redux'
import mekShopReducer from './mekShop.reducer'
/* Combining the reducers. */
const rootReducer = combineReducers({
    shop: mekShopReducer,
})
export default rootReducer